import { cn } from "utils";

export const ChatTabs = (props: {
  className?: string;
  onClick: (key: string) => void;
  activeKey?: string;
  time?: string;
}) => {
  const { className, onClick, activeKey = "result", time } = props;

  const items = [
    {
      key: "result",
      label: "Result",
    },
    {
      key: "thinking",
      label: `Thinking process${time ? ` (${time}s)` : ""}`,
    },
  ];

  return (
    <div className={cn("flex justify-start mb-4 w-full", className)}>
      <tab-indicator
        className="flex gap-6 overflow-x-auto flex-1 no-scrollbar [--underline-color:var(--edgen-border\_brand\_solid)] [--animation-duration:0.2s]"
        effect="underline"
      >
        {items.map((item) => (
          <div
            data-openreplay-label="chatbox_chattabs_click"
            key={item.key}
            role="tab-item"
            data-actived={activeKey === item.key}
            className="tab_item flex-shrink-0"
            onClick={() => onClick(item.key)}
          >
            <span className="py-[6px] button_l text-content_primary">
              {item.label}
            </span>
          </div>
        ))}
      </tab-indicator>
    </div>
  );
};
